export default {
  $modal: false,
  timeout: null,
  closed: false,
  openModal (type) {
    if (this.closed) {
      return
    }
    this.$modal.modal('show')
    window.dataLayer.push({ event: 'ody.newsletter-popup.opened', 'modal.open.type': type })
    if (this.useOnExitPopup()) {
      $(document).off('mouseout')
    }
    clearTimeout(this.timeout)
  },
  closeModal () {
    if (this.$modal) {
      this.$modal.modal('hide')
    }
  },
  useOnExitPopup () {
    const ua = window.navigator.userAgent;
    const isIE = /MSIE|Trident|Edge/.test(ua);

    return !isIE && (window.screen && window.screen.width > 768)
  },
  setSubscribedCookie () {
    const expiry = new Date(new Date().getTime() + 7889238E3);
    document.cookie = "MCPopupSubscribed\x3dyes;expires\x3d" + expiry.toUTCString() + ";path\x3d/";
  },
  setClosedCookie () {
    const expiry = new Date(new Date().getTime() + 31536E6);
    document.cookie =  "MCPopupClosed\x3dyes;expires\x3d" + expiry.toGMTString() + ";path\x3d/";
  },
  hasCookie () {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const name = cookies[i].split("\x3d")[0].trim()
      if (name === 'MCPopupClosed' || name === 'MCPopupSubscribed') {
        return true
      }
    }
    return false
  },
  ready ()  {
    this.$modal = $('#newsletterPopup')
    // set cookie on close so it doesnt pop back up
    this.$modal.on('hide.bs.modal', () => {
      this.setClosedCookie()
      this.closed = true
      window.dataLayer.push({ event: 'ody.newsletter-popup.closed' })
    })

    const $form = this.$modal.find('form')
    $form.on('submit', (e) => {
      e.preventDefault()

      $.post('/wp-json/newsletter/v1/submission', $form.serialize())
        .done(() => {
          this.setSubscribedCookie()
          const $alert = this.$modal.find('.alert-success')
          $alert.removeClass('hidden')
          $form.addClass('hidden')
          window.dataLayer.push({ event: 'ody.newsletter-popup.submit' })
        })
        .fail(data => {
          const $alert = $form.find('.alert-danger')
          $alert.html(data.responseJSON.result.title)
          $alert.removeClass('hidden')
          window.dataLayer.push({ event: 'ody.newsletter-popup.error', 'form.error': data.responseJSON.result.title })
        })
      return false;
    })

    if (this.useOnExitPopup()) {
      setTimeout(() => {
        $(document).mouseout((e) => {
          if (e.toElement === null && e.relatedTarget === null) {
            this.openModal('exit')
          }
        })
      }, 3000)
    }
    // always show modal after 60 seconds
    this.timeout = setTimeout(() => {
      this.openModal('timeout')
    }, 30000)
    // handle close separately so we can track gtm event
    $(document).on('click', '.newsletter-popup__close', () => {
      window.dataLayer.push({ event: 'ody.newsletter-popup.closed', 'modal.close.type': 'button' })
      this.closeModal()
    })
    $(document).on('click', '.newsletter-popup__not-interested', (e) => {
      e.preventDefault()
      window.dataLayer.push({ event: 'ody.newsletter-popup.closed', 'modal.close.type': 'text' })
      this.closeModal()
      return false
    })
  },
  shouldFire () {
    return false
  }
};
